// @flow

import { metaReducerFactory } from 'modules/common/state'
import { SESSION_FETCH, SESSION_FETCH_ACCESS_TOKEN, SESSION_FETCH_TAX_ACCOUNTANT_TOKEN } from '../actions'

const reducer = metaReducerFactory(SESSION_FETCH, SESSION_FETCH_ACCESS_TOKEN, SESSION_FETCH_TAX_ACCOUNTANT_TOKEN)

export default reducer
